import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import selectPerson from '@/components/select-person';
import config from '@/pathConfig';
import { batchUploadFile } from '@/api/commonApi.js';
import { queryNoticeFillDetails, saveFeedBack, queryFeedBackByUser, judgeDirector, judgeDirectorJWB } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    return {
      config: config,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      options: [],
      // 级联选择数据
      formObject: {},
      userInfo: this.$hdk.userInfo.get(),
      editor: null,
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入公告内容'
      },
      mode: 'default',
      // or 'default'
      formObjFeed: {
        fillId: this.$route.query.id,
        userName: '',
        organPostId: [],
        typeId: '',
        organId: '',
        postId: '',
        content: '',
        attach: []
      },
      rules: {
        content: [{
          required: true,
          message: '请输入反馈内容'
        }, {
          max: 500,
          message: '字数超出限制500'
        }],
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位'
        }]
      },
      fileObj: [],
      feedTitle: '反馈新增',
      isDirector: false,
      isDirectorJWB: false
    };
  },
  mounted: function mounted() {
    this.getNoticeFillDetails();
  },
  methods: {
    /**
     * 根据id查询详情
     */
    getNoticeFillDetails: function getNoticeFillDetails() {
      var _this = this;
      var $route = this.$route,
        userInfo = this.userInfo,
        formObject = this.formObject;
      this.formObjFeed.userName = userInfo.userName;

      // 级联数据处理 
      this.options = _.map(userInfo.organPostTree, function (item) {
        item.postList = _.map(item.postList, function (subItem) {
          return {
            label: subItem.postName,
            value: subItem.postId,
            children: null
          };
        });
        return {
          label: item.organName,
          value: item.organId,
          typeId: item.typeId,
          children: item.postList
        };
      });
      // 根据公告id查询反馈信息
      if ($route.query.status != null) {
        queryFeedBackByUser($route.query.id).then(function (res) {
          _this.formObjFeed = res.data.data;
          _this.feedTitle = '反馈详情';
          _this.formObjFeed.organAndPost = "".concat(_this.formObjFeed.organName, " / ").concat(_this.formObjFeed.postName);
          _this.formObjFeed.organPostId = [_this.formObjFeed.organId, _this.formObjFeed.postId];
          _this.fileObj = _.map(res.data.data.attach, function (item) {
            return {
              fileid: item.id,
              filename: item.fileName,
              filepath: item.filePath,
              uid: item.id,
              name: item.fileName,
              status: 'done',
              type: 1
            };
          });
        });
      }

      // 通知公告详情
      queryNoticeFillDetails($route.query.id).then(function (res) {
        _this.formObject = res.data.data;
        // 所属组织及岗位赋值
        _this.formObject.organAndPost = "".concat(_this.formObject.organName, " / ").concat(_this.formObject.postName);
        // 判断财务室主任提交时是否需要财务总监审核
        judgeDirector({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirector = res.data.data;
        });
        // 判断是否是纪委办主任
        judgeDirectorJWB({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirectorJWB = res.data.data;
        });
        // 当前组织层级指定人员
        if (_this.formObject.range === 3) {
          _this.optionVal = _.map(_this.formObject.scope, function (item) {
            return item.userId;
          });
        } else {
          _this.formObject.customize = {};
          // sendType 发送类型 0 个人 1 组织 2 岗位
          _this.formObject.customize.userData = [];
          _this.formObject.customize.organData = [];
          _this.formObject.customize.postData = [];
          _.forEach(_this.formObject.scope, function (item) {
            if (item.sendType === 0) {
              _this.formObject.customize.userData.push({
                id: item.userId,
                name: item.userName,
                type: 1
              });
            }
            if (item.sendType === 1) {
              _this.formObject.customize.organData.push({
                id: item.organId,
                name: item.organName,
                typeId: item.typeId
              });
            }
            if (item.sendType === 2) {
              _this.formObject.customize.postData.push({
                id: item.postId,
                name: item.postName,
                type: 2
              });
            }
          });
          _this.formObject.customize.organId = _this.formObject.organId;
          _this.formObject.customize.postId = _this.formObject.postId;
        }
      });
    },
    /**
     * 反馈新增提交
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var $refs = this.$refs,
        $confirm = this.$confirm,
        fileObj = this.fileObj,
        callSaveFeedBack = this.callSaveFeedBack;
      $refs.feedForm.validate(function (valid) {
        if (valid) {
          $confirm("确认提交吗?", "提示", {
            type: "info",
            confirmButtonText: "确认",
            cancelButtonText: "取消"
          }).then(function () {
            // 上传附件
            if (fileObj.length > 0) {
              var newFileObj = _.map(fileObj, function (item) {
                if (item.type === 0) {
                  return item;
                } else {
                  return;
                }
              });
              // 去除为空的
              newFileObj = _.compact(newFileObj);
              _this2.formObjFeed.attach = _.remove(fileObj, function (n) {
                if (n.type === 1) {
                  return n;
                }
              });
              if (newFileObj.length > 0) {
                batchUploadFile(fileObj).then(function (res) {
                  _.map(res.data.data, function (item) {
                    _this2.formObjFeed.attach.push({
                      filename: item.originalName,
                      filepath: item.filepath,
                      originalname: item.originalName
                    });
                  });
                  callSaveFeedBack();
                });
              } else {
                callSaveFeedBack();
              }
            } else {
              callSaveFeedBack();
            }
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    },
    callSaveFeedBack: function callSaveFeedBack() {
      var _this3 = this;
      var $message = this.$message,
        formObjFeed = this.formObjFeed,
        goBack = this.goBack;
      this.loading = true;
      saveFeedBack(_objectSpread({}, formObjFeed)).then(function (res) {
        if (res.data.code == 200) {
          $message.success('提交成功');
          goBack();
        }
        _this3.loading = false;
      });
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 文件删除
     */
    delFile: function delFile(data) {
      var fileObj = this.fileObj;
      if (1 === fileObj.length) {
        this.fileObj = [];
        this.formObjFeed.attach = [];
      } else {
        var evens = _.remove(fileObj, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.fileObj = evens;
        this.formObjFeed.attach = evens;
      }
    },
    /**
     * 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        fileObj = this.fileObj;
      if (fileObj.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      }
      // 用于上传后回显及往文件对象存值
      this.fileObj.push({
        fileid: data.file.uid,
        filename: data.file.name,
        fileSize: data.file.size,
        file: data.file,
        uid: data.file.uid,
        name: data.file.name,
        status: 'done',
        type: 0
      });
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var $set = this.$set,
        formObjFeed = this.formObjFeed;
      // 组织岗位赋值
      $set(formObjFeed, 'organId', value[0]);
      $set(formObjFeed, 'postId', value[1]);
      $set(formObjFeed, 'typeId', option[0].typeId);
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 编辑器
     */
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor.disable();
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      this.$router.push({
        path: '/docNotice/notice/feedManage'
      });
    }
  },
  components: {
    Editor: Editor,
    Toolbar: Toolbar,
    selectPerson: selectPerson
  }
};